function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "warning_svg__a",
  d: "M14.461 14H1.568a1.511 1.511 0 01-1.354-.819 1.64 1.64 0 010-1.618L6.661.818A1.555 1.555 0 018.013 0a1.512 1.512 0 011.354.818l6.448 10.746a1.65 1.65 0 010 1.618 1.511 1.511 0 01-1.354.818zm-6.432-4a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 00-1 1v3a1 1 0 002 0V5a1 1 0 00-1-1z"
});

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.027 14.001"
  }, props), _ref, _ref2);
}

export default SvgWarning;